/**
 * @generated SignedSource<<a943f9a9f1528cc47f6afe7c5ecbab5a>>
 * @relayHash dd1ae637836070dc4ac9fdea2d97f760
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5048f2060e2336647ba7161e68fb5d9832586acb8c17c47be8a5bbfa5f67888e

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type PTGraphQLPageStatus = "CURRENT" | "DRAFT" | "HISTORICAL" | "TRASHED" | "%future added value";
export type DualStreamQueriesFirstPageQuery$variables = {
  cloudId: string;
  contentId: string;
  first?: number | null;
  includeAutomationDiscovery?: boolean | null;
  includeDevDocsSyncStatus?: boolean | null;
  parentId: string;
  spaceKey?: string | null;
};
export type DualStreamQueriesFirstPageQuery$data = {
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly emojiTitlePublished: string | null;
      readonly id: string;
      readonly links: {
        readonly webui: string | null;
      } | null;
      readonly properties: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
        } | null> | null;
      } | null;
      readonly status: PTGraphQLPageStatus | null;
      readonly subType: string | null;
      readonly title: string | null;
      readonly type: string | null;
    } | null> | null;
    readonly pageInfo: {
      readonly endCursor: string | null;
      readonly hasNextPage: boolean;
    } | null;
  } | null;
  readonly folderViewActions?: {
    readonly " $fragmentSpreads": FragmentRefs<"FolderViewActions_query">;
  } | null;
  readonly folders: {
    readonly nodes: ReadonlyArray<{
      readonly emojiTitlePublished: string | null;
      readonly id: string;
      readonly links: {
        readonly webui: string | null;
      } | null;
      readonly properties: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
        } | null> | null;
      } | null;
      readonly status: PTGraphQLPageStatus | null;
      readonly subType: string | null;
      readonly title: string | null;
      readonly type: string | null;
    } | null> | null;
    readonly pageInfo: {
      readonly endCursor: string | null;
      readonly hasNextPage: boolean;
    } | null;
  } | null;
  readonly ptpage: {
    readonly id: string;
    readonly subType: string | null;
    readonly title: string | null;
    readonly type: string | null;
  } | null;
  readonly singleContent: {
    readonly contentProperties: {
      readonly latest: {
        readonly coverPicture: string | null;
      } | null;
    } | null;
    readonly devDocsOwnershipProperties: {
      readonly nodes: ReadonlyArray<{
        readonly id: string | null;
        readonly key: string | null;
      } | null> | null;
    } | null;
    readonly devDocsProperties?: {
      readonly nodes: ReadonlyArray<{
        readonly id: string | null;
        readonly key: string | null;
        readonly value: string | null;
      } | null> | null;
    } | null;
    readonly operations: ReadonlyArray<{
      readonly operation: string | null;
    } | null> | null;
    readonly properties: {
      readonly nodes: ReadonlyArray<{
        readonly id: string | null;
        readonly key: string | null;
        readonly value: string | null;
      } | null> | null;
    } | null;
  } | null;
};
export type DualStreamQueriesFirstPageQuery = {
  response: DualStreamQueriesFirstPageQuery$data;
  variables: DualStreamQueriesFirstPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v2 = {
  "defaultValue": 100,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeAutomationDiscovery"
},
v4 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeDevDocsSyncStatus"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "parentId"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v7 = {
  "kind": "ScalarField",
  "name": "id"
},
v8 = {
  "kind": "ScalarField",
  "name": "title"
},
v9 = {
  "kind": "ScalarField",
  "name": "type"
},
v10 = {
  "kind": "ScalarField",
  "name": "subType"
},
v11 = {
  "args": [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "parentId"
    },
    {
      "kind": "Literal",
      "name": "status",
      "value": [
        "CURRENT",
        "DRAFT"
      ]
    }
  ],
  "concreteType": "PTPage",
  "kind": "LinkedField",
  "name": "ptpage",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    (v8/*: any*/),
    (v9/*: any*/),
    (v10/*: any*/)
  ]
},
v12 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "contentId"
  }
],
v13 = {
  "concreteType": "OperationCheckResult",
  "kind": "LinkedField",
  "name": "operations",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "operation"
    }
  ]
},
v14 = {
  "concreteType": "ContentProperties",
  "kind": "LinkedField",
  "name": "contentProperties",
  "plural": false,
  "selections": [
    {
      "concreteType": "PublishedContentProperties",
      "kind": "LinkedField",
      "name": "latest",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "coverPicture"
        }
      ]
    }
  ]
},
v15 = {
  "kind": "ScalarField",
  "name": "key"
},
v16 = {
  "kind": "ScalarField",
  "name": "value"
},
v17 = [
  {
    "concreteType": "JsonContentProperty",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      (v7/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/)
    ]
  }
],
v18 = {
  "args": [
    {
      "kind": "Literal",
      "name": "keys",
      "value": [
        "smartFolderProperties"
      ]
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": (v17/*: any*/),
  "storageKey": "properties(keys:[\"smartFolderProperties\"])"
},
v19 = [
  {
    "kind": "Literal",
    "name": "keys",
    "value": [
      "devdocsProperties"
    ]
  }
],
v20 = {
  "alias": "devDocsOwnershipProperties",
  "args": (v19/*: any*/),
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": [
    {
      "concreteType": "JsonContentProperty",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v7/*: any*/),
        (v15/*: any*/)
      ]
    }
  ],
  "storageKey": "properties(keys:[\"devdocsProperties\"])"
},
v21 = {
  "condition": "includeDevDocsSyncStatus",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": "devDocsProperties",
      "args": (v19/*: any*/),
      "concreteType": "PaginatedJsonContentPropertyList",
      "kind": "LinkedField",
      "name": "properties",
      "plural": false,
      "selections": (v17/*: any*/),
      "storageKey": "properties(keys:[\"devdocsProperties\"])"
    }
  ]
},
v22 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v23 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v24 = {
  "kind": "Variable",
  "name": "parentId",
  "variableName": "parentId"
},
v25 = {
  "kind": "Variable",
  "name": "spaceKey",
  "variableName": "spaceKey"
},
v26 = [
  (v22/*: any*/),
  (v23/*: any*/),
  (v24/*: any*/),
  (v25/*: any*/),
  {
    "kind": "Literal",
    "name": "type",
    "value": "FOLDER"
  }
],
v27 = {
  "kind": "ScalarField",
  "name": "status"
},
v28 = {
  "kind": "ScalarField",
  "name": "emojiTitlePublished"
},
v29 = {
  "concreteType": "Map_LinkType_String",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "webui"
    }
  ]
},
v30 = {
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": (v17/*: any*/)
},
v31 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    },
    {
      "kind": "ScalarField",
      "name": "endCursor"
    }
  ]
},
v32 = [
  {
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      (v7/*: any*/),
      (v8/*: any*/),
      (v27/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v28/*: any*/),
      (v29/*: any*/),
      (v30/*: any*/)
    ]
  },
  (v31/*: any*/)
],
v33 = [
  (v22/*: any*/),
  (v23/*: any*/),
  (v24/*: any*/),
  (v25/*: any*/),
  {
    "kind": "Literal",
    "name": "type",
    "value": "CONTENT"
  }
],
v34 = [
  {
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "__typename"
      },
      (v7/*: any*/),
      (v8/*: any*/),
      (v27/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v28/*: any*/),
      (v29/*: any*/),
      (v30/*: any*/)
    ]
  },
  (v31/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "name": "DualStreamQueriesFirstPageQuery",
    "selections": [
      {
        "condition": "includeAutomationDiscovery",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "fragment": {
              "kind": "InlineFragment",
              "selections": [
                {
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "contentId",
                      "variableName": "contentId"
                    }
                  ],
                  "kind": "FragmentSpread",
                  "name": "FolderViewActions_query"
                }
              ],
              "type": "Query"
            },
            "kind": "AliasedInlineFragmentSpread",
            "name": "folderViewActions"
          }
        ]
      },
      (v11/*: any*/),
      {
        "args": (v12/*: any*/),
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "singleContent",
        "plural": false,
        "selections": [
          (v13/*: any*/),
          (v14/*: any*/),
          (v18/*: any*/),
          (v20/*: any*/),
          (v21/*: any*/)
        ]
      },
      {
        "alias": "folders",
        "args": (v26/*: any*/),
        "concreteType": "ConfluenceContentTreeItemConnection",
        "kind": "LinkedField",
        "name": "confluence_contentTreeChildren",
        "plural": false,
        "selections": (v32/*: any*/)
      },
      {
        "alias": "content",
        "args": (v33/*: any*/),
        "concreteType": "ConfluenceContentTreeItemConnection",
        "kind": "LinkedField",
        "name": "confluence_contentTreeChildren",
        "plural": false,
        "selections": (v32/*: any*/)
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "DualStreamQueriesFirstPageQuery",
    "selections": [
      (v11/*: any*/),
      {
        "args": (v12/*: any*/),
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "singleContent",
        "plural": false,
        "selections": [
          (v13/*: any*/),
          (v14/*: any*/),
          (v18/*: any*/),
          (v20/*: any*/),
          (v21/*: any*/),
          (v7/*: any*/)
        ]
      },
      {
        "alias": "folders",
        "args": (v26/*: any*/),
        "concreteType": "ConfluenceContentTreeItemConnection",
        "kind": "LinkedField",
        "name": "confluence_contentTreeChildren",
        "plural": false,
        "selections": (v34/*: any*/)
      },
      {
        "alias": "content",
        "args": (v33/*: any*/),
        "concreteType": "ConfluenceContentTreeItemConnection",
        "kind": "LinkedField",
        "name": "confluence_contentTreeChildren",
        "plural": false,
        "selections": (v34/*: any*/)
      },
      {
        "condition": "includeAutomationDiscovery",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "user",
            "args": [
              {
                "kind": "Literal",
                "name": "current",
                "value": true
              }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
              {
                "concreteType": "AtlassianUserEmail",
                "kind": "LinkedField",
                "name": "emails",
                "plural": true,
                "selections": [
                  (v16/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "isPrimary"
                  }
                ]
              },
              (v7/*: any*/)
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
          },
          {
            "args": (v12/*: any*/),
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
              {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "ancestors",
                "plural": true,
                "selections": [
                  (v7/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "dd1ae637836070dc4ac9fdea2d97f760",
    "id": "5048f2060e2336647ba7161e68fb5d9832586acb8c17c47be8a5bbfa5f67888e",
    "metadata": {},
    "name": "DualStreamQueriesFirstPageQuery",
    "operationKind": "query",
    "text": "query DualStreamQueriesFirstPageQuery($cloudId:ID!,$parentId:ID!,$spaceKey:String,$contentId:ID!,$first:Int=100,$includeDevDocsSyncStatus:Boolean=false,$includeAutomationDiscovery:Boolean=false){...FolderViewActions_query_3SK5LQ@include(if:$includeAutomationDiscovery),ptpage(id:$parentId,status:[CURRENT,DRAFT]){id,title,type,subType},singleContent(id:$contentId){operations{operation},contentProperties{latest{coverPicture}},properties(keys:[\"smartFolderProperties\"]){nodes{id,key,value}},devDocsOwnershipProperties:properties(keys:[\"devdocsProperties\"]){nodes{id,key}},devDocsProperties:properties(keys:[\"devdocsProperties\"])@include(if:$includeDevDocsSyncStatus){nodes{id,key,value}},id},folders:confluence_contentTreeChildren(cloudId:$cloudId,parentId:$parentId,spaceKey:$spaceKey,type:FOLDER,first:$first){nodes{__typename,id,title,status,type,subType,emojiTitlePublished,links{webui},properties{nodes{id,key,value}}},pageInfo{hasNextPage,endCursor}},content:confluence_contentTreeChildren(cloudId:$cloudId,parentId:$parentId,spaceKey:$spaceKey,type:CONTENT,first:$first){nodes{__typename,id,title,status,type,subType,emojiTitlePublished,links{webui},properties{nodes{id,key,value}}},pageInfo{hasNextPage,endCursor}}}fragment AutomationActionsMenu_query_3SK5LQ on Query{...useKeepUpToDateAction_query_3SK5LQ}fragment FolderViewActions_query_3SK5LQ on Query{...AutomationActionsMenu_query_3SK5LQ}fragment useKeepUpToDateAction_query_3SK5LQ on Query{user:confluence_atlassianUser(current:true){emails{value,isPrimary},id},singleContent(id:$contentId){ancestors{id},id}}"
  }
};
})();

(node as any).hash = "123a1f6e537c7840d6fffb164868a3d2";

export default node;
